import { Component, input, output, computed } from '@angular/core';
import { NgClass } from '@angular/common';
import { ZendraLocalizationPipe } from '../pipes/zendra-localization.pipe';

@Component({
  selector: 'zn-pill',
  standalone: true,
  imports: [NgClass, ZendraLocalizationPipe],
  styleUrls: ['./zn-pill.scss'],
  templateUrl: './zn-pill.html',
})
export class ZnPill {
  label = input<string>();
  disabled = input<boolean>(false);
  removable = input<boolean>(false);

  variant = input<'data'>('data');

  removed = output<void>();

  variantClass = computed(() => {
    const map = {
      data: 'zn-pill--data',
    };

    return map[this.variant()];
  });
}
// USAGE

// TS 
// tags = signal([
//   { id: 1, label: 'John Deere' },
//   { id: 2, label: 'CAT' },
//   { id: 3, label: 'JAC' },
// ]);

// HTML

// @for (tag of tags(); track tag.id) {
//   <zn-pill
//     [label]="tag.label"
//     [removable]="true"
//     (removed)="removeTag(tag.id)"
//   />
// }

// Logic

// removeTag(id: number) {
//   this.tags.update(tags => tags.filter(t => t.id !== id));
// }
